import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { FarewellScreen } from "@/features/user/farewell-screen"

type Props = {
  locationName: string | null
  tableName: string | null
  billId: number | null
}

export default function UserVisitsFarewell() {
  const { locationName, tableName, billId } = usePage<Props>().props

  return (
    <UserLayout cartCount={0}>
      <FarewellScreen locationName={locationName} tableName={tableName} billId={billId} />
    </UserLayout>
  )
}
